/** Read global lead-pool assignable roles from localStorage (set via Lead Pools → Roles). */
export function getLeadPoolAllowedRoles() {
  try {
    const roles = JSON.parse(localStorage.getItem('crmLeadPoolAllowedRoles') || '[]');
    return Array.isArray(roles) ? roles : [];
  } catch {
    return [];
  }
}

/** Build query params for GET /users/assignable role filter. */
export function getLeadPoolAssignableRoleParams() {
  const roles = getLeadPoolAllowedRoles();
  return roles.length > 0 ? { roles: roles.join(',') } : {};
}
